import * as Yup from "yup";

const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,63})$/;

export const forgetMailPassSchema = Yup.object().shape({
  email: Yup.string()
    .matches(emailReg, { message: "Invalid email" })
    .required("Required"),
});
export const signInSchema = Yup.object().shape({
  email: Yup.string()
    .matches(emailReg, { message: "Invalid email" })
    .required("Required"),
  password: Yup.string().when(["isEmailVerified"], (value, schema) => {
    const [isEmailVerified] = value;
    return isEmailVerified ? schema.required("Password is required") : schema;
  }),
  isEmailVerified: Yup.boolean(),
});
export const setPasswordSchema = Yup.object().shape({
  newPassword: Yup.string().required("Required"),

  ConfirmPassword: Yup.string()
    .required("Required")
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
});
export const signWithPassSchema = Yup.object().shape({
  email: Yup.string()
    .matches(emailReg, { message: "Invalid email" })
    .required("Required"),
  password: Yup.string().required("Required"),
});
